/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {verifyQrCode} from '../api'

export const useMutationVerifyQrCode = createReactQueryMutationHook('verifyQrCode', verifyQrCode)
